module.exports = __webpack_public_path__ + "static/img/down_btn4.84cb716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn4.png
// module id = GdHC
// module chunks = 4